import { render, staticRenderFns } from "./Consequences.vue?vue&type=template&id=156f15fd&"
import script from "./Consequences.vue?vue&type=script&lang=js&"
export * from "./Consequences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156f15fd')) {
      api.createRecord('156f15fd', component.options)
    } else {
      api.reload('156f15fd', component.options)
    }
    module.hot.accept("./Consequences.vue?vue&type=template&id=156f15fd&", function () {
      api.rerender('156f15fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/Consequences.vue"
export default component.exports